export default __webpack_public_path__ + "17f090e9db41f64e27e25199735ee0ff.ttf";